import { validationStrings } from '@strata/strata-ui-strings';
import * as Yup from 'yup';

export const TherapyGroupNamePattern = /^[a-z][a-z0-9]*(_[a-z0-9]+)*\.tg$/;
export const TherapyGroupNameFormatMessage = 'Must be lowercase snake_case ending in .tg';

export const DisplayNameHelperText =
    'Will be used as the display name throughout Lucent when referring to this list.';
const IdentityRequiredMessage = 'Enter a therapy group identifier and name before saving.';

export const therapyGroupNameSchema = Yup.string()
    .max(50, validationStrings.maxCharacter[50])
    .required(validationStrings.requiredField.errorMessage)
    .matches(TherapyGroupNamePattern, TherapyGroupNameFormatMessage);

export const descriptionSchema = Yup.string()
    .max(100, validationStrings.maxCharacter[100])
    .required(validationStrings.requiredField.errorMessage);

// Creating a group writes it before its first link or preference, so check its identity first.
export const requireTherapyGroupIdentity = async (values) => {
    try {
        await Yup.object({
            therapyGroupName: therapyGroupNameSchema,
            description: descriptionSchema,
        }).validate({
            therapyGroupName: values.therapyGroupName,
            description: values.description,
        });
    } catch {
        throw new Error(IdentityRequiredMessage);
    }
};
